import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasEyectoras/BombasEyectoras1.png';
import Img2 from '../../img/products/bombas/BombasEyectoras/BombasEyectoras2.png';
import Img3 from '../../img/products/bombas/BombasEyectoras/BombasEyectoras3.png';
import Img4 from '../../img/products/bombas/BombasEyectoras/BombasEyectoras4.png';

const BombasEyectoras = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas Eyectoras</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-5">
        {/* Columna izquierda: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas sumergibles eyectoras combinan las características de una bomba sumergible y 
            una bomba eyectora para ofrecer una solución eficiente y confiable en aplicaciones donde 
            el nivel del agua puede variar significativamente. Estas bombas son especialmente útiles 
            en pozos profundos y otras aplicaciones subterráneas. 
          </p>
          <p className="lead text-justify">
            La bomba está diseñada para operar completamente sumergida en el agua, lo que elimina la 
            necesidad de cebado y reduce el riesgo de cavitación. Utiliza un inyector (o eyector) que 
            crea un vacío y facilita la elevación del agua desde grandes profundidades. 
          </p>
          <p className="lead text-justify">
            Al estar sumergidas, estas bombas no necesitan gastar energía en levantar el agua hasta 
            la bomba, lo que mejora la eficiencia energética. Al estar sumergidas en el agua, las bombas 
            operan demanera silenciosa, ideal para aplicaciones residenciales y comerciales.
          </p>
        </div>

        {/* Columna derecha: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-4">
            <div className="col-5">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-5">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
            <div className="col-5">
              <img src={Img3} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 3" />
            </div>
            <div className="col-5">
              <img src={Img4} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 4" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BombasEyectoras;
